import { createI18n } from 'vue-i18n';
import assetZh from './asset';
import fundZh from './fund';

// 中文语言包
const zh = {
  nav: {
    home: '首页',
    holdings: '我的资产',
    transactions: '交易记录',
    funds: '基金产品',
    messages: '信息收集 Information Collection',
    profile: '个人中心'
  },
  common: {
    loading: '加载中...',
    noData: '暂无数据',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    back: '返回',
    more: '更多',
    search: '搜索',
    filter: '筛选'
  },
  auth: {
    login: '登录',
    phone: 'Email',
    code: '验证码',
    sendCode: '发送验证码',
    resendCode: '重新发送',
    loginSuccess: '登录成功',
    phoneRequired: '请输入 Email',
    codeRequired: '请输入验证码'
  },
  holding: {
    totalValue: '总资产',
    totalProfit: '累计收益',
    totalInvestment: '累计投资',
    profitRate: '收益率',
    shares: '持有份额',
    holdingShares: '持仓份额',
    navValue: '持仓净值',
    currentNav: '当前净值',
    holdingDetail: '持仓详情'
  },
  transaction: {
    type: '交易类型',
    date: '结算日期',
    shares: '份额',
    price: '确认价格',
    amount: '金额',
    issue: '认购',
    redeem: '赎回',
    transfer: '转换'
  },
  fund: {
    name: '基金名称',
    code: '基金代码',
    nav: '单位净值',
    navDate: '净值日期',
    compare: '对比',
    performance: '业绩走势'
  },
  message: {
    pageTitle: '信息收集 Information Collection',
    newMessage: '新建信息 New Message',
    content: '内容 Content',
    contentPlaceholder: '请输入您的问题或建议... Enter your question or suggestion...',
    submit: '提交 Submit',
    submitting: '提交中... Submitting...',
    pending: '待回复 Pending',
    replied: '已回复 Replied',
    reply: '客服回复： CS Reply:',
    noMessages: '暂无信息 No Messages',
    noMessagesHint: '点击右上角 + 提交您的问题 Tap + to submit your question',
    complianceText: '合规声明 Compliance Notice'
  },
  home: {
    relatedAssets: '关联资产 Related Assets',
    totalAssets: '总资产 Total Assets',
    associatedAccounts: '关联账户 Associated Accounts',
    investorId: 'Investor ID',
    class: 'CLASS',
    noInvestors: '暂无关联账户',
    loginOut: '退出登录'
  },
  asset: assetZh.asset
};

// Merge fund translations into existing fund namespace
Object.assign(zh.fund, fundZh.fund);

const i18n = createI18n({
  legacy: false,
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: {
    zh
  }
});

export default i18n;
